const ghostSearch = (evt) => {
  evt.preventDefault();
  const q = document.querySelector("#ghost-search-field");
  const p = q.parentElement;
  if (p.style.display === "block") {
    p.style.display = "none";
  } else {
    document.body.classList.remove("gh-head-open");
    p.style.display = "block";
    q.focus();
  }
};
